import 'cropperjs/dist/cropper.css';
import moment from 'moment';
import { useRef, useState } from 'react';
import Cropper from 'react-cropper';

const ImageCropperLogo = ({ isOpen, onClose, onCrop, imageType, memberID }) => {
    const cropperRef = useRef(null);
    const fileInputRef = useRef(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const [fileName, setFileName] = useState('');

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const maxFileSize = 1000 * 1024;
            if (file.size > maxFileSize) {
                alert('업로드 파일의 사이즈는 1,000KB까지 가능합니다.');
                e.target.value = '';
                return;
            }
            const fileFormat = file.name.split('.').pop().toLowerCase();
            setFileName(`CP_${memberID}_${moment().format('YYYYMMDDHHmmss')}.${fileFormat}`);
            const reader = new FileReader();
            reader.onload = () => setImageSrc(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleCrop = () => {
        if (!imageSrc) {
            alert('등록할 이미지가 없습니다.');
            return;
        }

        if (!window.confirm('미리보기 이미지에서 보이는 이미지대로 등록하시겠습니까?')) {
            return;
        }
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
            const croppedCanvas = cropper.getCroppedCanvas({
                width: 200,
                height: 55,
                imageSmoothingQuality: 'high',
            });

            croppedCanvas.toBlob((blob) => {
                if (blob) {
                    const croppedImageUrl = URL.createObjectURL(blob);
                    const croppedFile = new File([blob], fileName);
                    onCrop(croppedImageUrl, croppedFile, imageType);
                    handleClose();
                }
            }, 1);
        }

        alert('변경되었습니다.');
    };

    const handleClose = () => {
        setImageSrc(null);
        setCroppedImage(null);
        setFileName('');
        if (fileInputRef.current) fileInputRef.current.value = '';
        if (cropperRef.current?.cropper) {
            cropperRef.current.cropper.destroy();
        }

        onClose();
    };

    if (!isOpen) return null;

    return (
        <div
            id="ImageCropperLogo"
            className="modal show d-block modal-logo"
            tabIndex="-1"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
            <div className="resume_picture">
                {/* Header */}
                <div className="modal-header border-0">
                    <h5 className="modal-title fw-bold">치과 로고 등록</h5>
                    <button type="button" className="btn-close" onClick={handleClose}></button>
                </div>

                {/* Body */}
                <div className="modal-body">
                    {/* Instructions */}
                    <ol className="notice_box">
                        <li>
                            [파일 선택]을 클릭, 등록할 이미지를 선택한 후, 로고로 사용할 영역을 마우스로 드래그하여
                            선택해 주세요.
                        </li>
                        <li>미리보기 이미지에 원하는 영역 선택이 완료되면 [등록]을 클릭해 주세요.</li>
                    </ol>

                    {/* Image Preview and Cropper */}
                    <div className="picture_box">
                        <div className="picture_before">
                            <h6 className="tit">원본 이미지</h6>
                            <div className="picture">
                                {imageSrc ? (
                                    <Cropper
                                        src={imageSrc}
                                        style={{ width: 200 }}
                                        aspectRatio={200 / 50}
                                        guides={true}
                                        viewMode={1}
                                        minCropBoxHeight={50}
                                        minCropBoxWidth={50}
                                        background={false}
                                        responsive={true}
                                        autoCropArea={200 / 50}
                                        checkOrientation={false}
                                        ref={cropperRef}
                                        preview={'.previewArea'}
                                    />
                                ) : (
                                    <span>편집할 이미지를 등록해주세요</span>
                                )}
                            </div>
                        </div>
                        <div className="picture_after">
                            <h6 className="tit">미리보기 이미지</h6>
                            <div className="picture">
                                <div className="img previewArea" style={{ width: 200, height: 50 }}>
                                    {croppedImage && <img src={croppedImage} alt="Cropped" className="img-fluid" />}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* File Input */}
                    <div className="file_box">
                        <input
                            type="file"
                            accept="image/jpeg,image/png,image/gif"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                    </div>
                    <p className="txt">・이미지 파일은 1,000KB 미만의 JPG, JPEG, PNG, GIF 파일만 업로드 가능.</p>
                    <p className="txt">・이미지 크기는 200*50 픽셀로 노출됩니다.</p>
                </div>

                {/* Footer */}
                <div className="resume__btbx">
                    <button type="button" className="resume__btn" onClick={handleClose}>
                        취소
                    </button>
                    <button type="button" className="resume__btn resume__btn--blue" onClick={handleCrop}>
                        등록
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropperLogo;
